import React, { useEffect, useState } from 'react';
// import { ReactComponent as SoundIcon } from 'images/sports/menu/notice.svg';
// import { ReactComponent as PromptIcon } from 'images/sports/menu/pc-browser.svg';
import Switch from 'components/switch';
import useLocalStorage from 'hooks/useLocalStorage';
import style from './style.module.scss';

const SoundPromptSettings = ({ sportsType }) => {
  const { setItem } = useLocalStorage();
  const [settings, setSettings] = useState({ audio: false, prompt: false });

  useEffect(() => {
    const { scoreSettings } = window;

    if (!!scoreSettings && !!scoreSettings[sportsType]) {
      setSettings(scoreSettings[sportsType]);
    }
  }, []);

  const onChangeSettings = (key) => {
    const { scoreSettings } = window;
    const bool = !scoreSettings[sportsType][key];

    scoreSettings[sportsType][key] = bool;

    setItem('scoreSettings', JSON.stringify(scoreSettings));

    setSettings({
      ...settings,
      [key]: bool
    });
  };

  return (
    <>
      {sportsType === 'soccer' && (
        <div className={style.settings}>
          <div className={style.settings_on_off}>
            <Switch
              checked={settings.audio}
              toggleChecked={() => onChangeSettings('audio')}
            />
          </div>
          <div className={style.settings_text}>
            {/* <SoundIcon /> */}
            <span>사운드</span>
          </div>
        </div>
      )}
      <div className={style.settings}>
        <div className={style.settings_on_off}>
          <Switch
            checked={settings.prompt}
            toggleChecked={() => onChangeSettings('prompt')}
          />
        </div>
        <div className={style.settings_text}>
          {/* <PromptIcon /> */}
          <span>프롬프트</span>
        </div>
      </div>
    </>
  );
};

export default SoundPromptSettings;
